var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Welcome',{attrs:{"msg":"Bienvenidos a Centro Medico Terrada"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }